import React, { useReducer, useMemo } from 'react'
import Modal from 'antd/lib/modal'
import message from 'antd/lib/message'
import moment from 'moment-timezone'

import EventForm, { SET_TAG } from 'components/EventForm'
import { apiManager, constants } from 'helpers'
import useAuthState from 'hooks/useAuthState'

const {
  EVENT_CONSTANTS: { NON_ADMIN_START_WEEKS },
} = constants

const initialState = {
  title: '',
  imageData: null,
  verticalImageData: null,
  description: '',
  eventFormat: 'match',
  eventVisibility: 'Private',
  recurrenceFrequency: null,
  recurrenceQuantity: null,
  location: null,
  ticketPrice: 20,
  ticketQuantity: {
    MALE: 5,
    FEMALE: 5,
  },
  sexualOrientationV1: [],
  tags: {},
  slug: '',
  minAge: 20,
  maxAge: 35,
  scheduled: true,
  bacheloretteUserId: '',
}

const reducer = (state, originalAction) => {
  const { type, ...action } = originalAction
  switch (type) {
    case SET_TAG: {
      const { tag, ...rest } = action
      return {
        ...state,
        ...rest,
        tags: {
          ...state.tags,
          ...tag,
        },
      }
    }
    default:
      return {
        ...state,
        ...action,
      }
  }
}

const NewEventPage = props => {
  const { user } = useAuthState()
  const startTime = useMemo(
    () =>
      user.admin || user.Host.level === '3'
        ? moment().add(1, 'hour').startOf('hour')
        : moment().add(NON_ADMIN_START_WEEKS, 'week').startOf('hour'),
    [user]
  )

  const [formState, setFormState] = useReducer(reducer, {
    ...initialState,
    startTime,
  })

  const handleChange = e => setFormState({ [e.target.name]: e.target.value })

  const createEvent = async () => {
    message.loading('Creating event...', 0)
    const { ticketQuantity, sexualOrientationV1, ...data } = formState
    let tags = formState.tags
    if (sexualOrientationV1.length) {
      tags = {
        ...formState.tags,
        sexual_orientation: sexualOrientationV1,
      }
    }
    const eventData = {
      ...data,
      tags,
      leftTickets: ticketQuantity.MALE,
      rightTickets: ticketQuantity.FEMALE,
    }
    await apiManager.createEvent(eventData)
    Modal.success({
      title: 'New Event Created',
      content:
        'Newly created events will be first reviewed and turned into an active event if approved',
    })
    message.destroy()
    props.history.push('/portal')
  }

  return (
    <div className="flex justify-between px-5 md:py-14 md:px-20 lg:px-0 text-black bg-background md:mx-0 lg:mx-40">
      <EventForm
        formState={formState}
        setFormState={setFormState}
        handleChange={handleChange}
        createEvent={createEvent}
        formType="create"
      />
    </div>
  )
}

export default NewEventPage
